export function formatNumber(n) {
  return new Intl.NumberFormat().format(n ?? 0);
}
